// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___2_cnr","circle":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___3pP-N","content":"app-pages-Reports-Sales-GrossProfit-WarningLabel-__WarningLabel___2VL9i"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/GrossProfit/WarningLabel/WarningLabel.css
// module id = 2219
// module chunks = 0